const CONFIG = {
  APP_NAME: "NeroSs DApp",
  APP_URL: "http://localhost:3000",
  APP_ID: "561",
  GOOGLE_CLIENT_ID:
    "713121082738-m96mkqdrl83ptdjn224e46ik8ergep6r.apps.googleusercontent.com",
};

export default CONFIG;
